import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { closeSingleAlert, selectAlerts } from "src/modules/notification/redux";
import SnackBarComponent from "./snackBar.component";

function SnackBarContainer({ alerts, closeAlert }) {
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = (event, reason) => {
    // if (reason === 'clickaway') {
    //   return;
    // }
    setIsOpen(false);
    closeAlert();
  };

  useEffect(() => {
    if (alerts.length !== 0) {
      setMessage(alerts[0].message);
      setIsOpen(true);
    }
  }, [alerts]);

  if (alerts.length !== 0) {
    return (
      <SnackBarComponent
        notification={alerts[0]}
        isOpen={isOpen}
        handleClose={handleClose}
        message={message}
      />
    );
  }

  return null;
}

const mapStateToProps = (state) => ({
  alerts: selectAlerts(state),
});

const mapDispatchToProps = (dispatch) => ({
  closeAlert: () => dispatch(closeSingleAlert()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SnackBarContainer);
